import { z } from 'zod';

/** Debe coincidir con VacationConstants.MAX_DAY_COUNT del backend. */
export const VACATION_MAX_DAY_COUNT = 180;
/** Debe coincidir con VacationConstants.MAX_DETAIL_LENGTH del backend. */
export const VACATION_MAX_DETAIL_LENGTH = 100;

const createVacationBaseSchema = z.object({
  employeeTargetId: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:vacation.validation.employeeRequired' })
      .int()
      .positive('absence:vacation.validation.employeeRequired'),
    z.null(),
  ]),
  workdayType: z.string().min(1, 'absence:vacation.validation.workdayTypeRequired'),
  dayCount: z.union([
    z.coerce
      .number({ invalid_type_error: 'absence:vacation.validation.dayCountRequired' })
      .int('absence:vacation.validation.dayCountInteger')
      .positive('absence:vacation.validation.dayCountRequired')
      .max(VACATION_MAX_DAY_COUNT, 'absence:vacation.validation.dayCountMaxLength'),
    z.null(),
  ]),
  startDate: z
    .string()
    .min(1, 'absence:vacation.validation.startDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:vacation.validation.invalidDateFormat'),
  // Fecha de término y fecha de retorno las calcula el backend en días hábiles; el formulario solo
  // las muestra. Se exigen no vacías para que Guardar no pueda ejecutarse antes del cálculo.
  endDate: z
    .string()
    .min(1, 'absence:vacation.validation.endDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:vacation.validation.invalidDateFormat'),
  returnDate: z
    .string()
    .min(1, 'absence:vacation.validation.returnDateRequired')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'absence:vacation.validation.invalidDateFormat'),
  detail: z
    .union([z.string().max(VACATION_MAX_DETAIL_LENGTH, 'absence:vacation.validation.detailMaxLength'), z.null()])
    .optional()
    .default(null)
    .transform((value) => value ?? ''),
});

export const createVacationFormSchema = createVacationBaseSchema
  .refine((data) => data.employeeTargetId !== null, {
    message: 'absence:vacation.validation.employeeRequired',
    path: ['employeeTargetId'],
  })
  .refine((data) => data.dayCount !== null, {
    message: 'absence:vacation.validation.dayCountRequired',
    path: ['dayCount'],
  });

export type CreateVacationFormValues = z.infer<typeof createVacationFormSchema>;
